import wretch from 'wretch';
import { log } from '../log';

/**
 * @name ForumWretch
 * @description Api client using wretch
 */
export const ForumWretch = wretch('https://forums.unraid.net')
  .options({ mode: 'cors' })
  .catcher(error => log.error(error));
/**
 * @name KeyServerWretch
 * @description Api client using wretch
 */
export const KeyServerWretch = wretch('https://keys.lime-technology.com')
  .catcher(error => log.error(error));
/**
 * @name WanIp
 * @description used to get client's wanip to determine what URL to present in server list
 * @type GET
 * @returns {string}
 */
export const WanIp = wretch('https://wanip4.unraid.net/')
  .catcher(error => log.error(error));
/**
 * @name WebguiInstallKey
 * @description used to auto install key urls
 * @type GET - data should be passed using wretch's `.query({ url: String })`
 * @param {string} url - URL of license key
 */
export const WebguiInstallKey = wretch('/webGui/include/InstallKey.php')
  .catcher(error => log.error(error));
/**
 * @name WebguiState
 * @description frequently polled by UPC to keep UPC state update to date. Also used to populate pop-ups using postmessages.
 * @see - most include `.url(String)` since we allow the URL to be modified
 * @type GET
 */
export const WebguiState = wretch()
  .catcher(error => log.error(error));
/**
 * @type POST
 * @dataType - `formUrl(Object)` https://github.com/elbywan/wretch#formurlinput-object--string
 * @param {string} csrf_token
 * @param {string} '#file' - ex:  getters.myServersCfgPath
 * @param {string} '#section' - ex:  'remote'
 * @param {string} apikey
 * @param {string} avatar
 * @param {string} email
 * @param {string} username
 */
export const WebguiUpdate = wretch('/update.php')
  .catcher(error => log.error(error));
/**
 * @name WebguiUpdateDns
 * @description used after Sign In to ensure URLs will work correctly
 * @type POST
 */
export const WebguiUpdateDns = wretch('/webGui/include/UpdateDNS.php')
  .catcher(error => log.error(error));
/**
 * @name WebguiUpdateDns
 * @description used after Sign In to ensure URLs will work correctly
 * @type POST
 */
export const WebguiUnraidApiCommand = wretch('/plugins/dynamix.my.servers/include/unraid-api.php')
  .catcher(error => log.error(error));
